import React, { useState } from "react";
import { observer } from "mobx-react";
import { FiLock } from "react-icons/fi";
import PeopleStore from "../../../../../stores/PeopleStore";
import { Button, Input, Spinner } from "../../../../-common";
import "./ChangeEmailModal.scss";

function ChangeEmailModal({ user, close }) {
  const { firstName } = user || {};
  const [newEmail, setNewEmail] = useState("");
  const updateNewEmail = ({ target }) => setNewEmail(target.value);

  const [loading, setLoading] = useState(false);

  const changeEmailEnabled = newEmail?.length >= 6;
  const changeEmail = async () => {
    if (changeEmailEnabled) {
      setLoading(true);
      await PeopleStore?.changeEmailForUser(user, newEmail);
      setLoading(false);
      close();
    }
  };

  const actionButtonStyles = loading ? { opacity: 0.3, pointerEvents: "none" } : {};
  const actionButtonContent = loading ? <Spinner /> : "Submit";

  return (
    <div className="change-email-modal">
      <div className="content">
        <div className="title">Change {firstName}&#39;s Email</div>
        <div className="message">
          This will change the email address they use to log in permanently and immediately. They will also need to use
          the new email if they try to reset their password.
        </div>
        <div className="input-wrapper">
          <Input
            icon={FiLock}
            type="text"
            placeholder="New Email"
            value={newEmail}
            onChange={updateNewEmail}
            pattern="[0-9]*"
            inputmode="numeric"
          />
        </div>
      </div>
      <div className="bottom-buttons">
        <div className="left-buttons">
          <Button type="secondary" action={close}>
            Cancel
          </Button>
        </div>
        <div className="right-buttons">
          <Button
            type="primary"
            className="send-request-button"
            action={changeEmail}
            disabled={!changeEmailEnabled}
            style={actionButtonStyles}
          >
            {actionButtonContent}
          </Button>
        </div>
      </div>
    </div>
  );
}

export default observer(ChangeEmailModal);
